/**!
 * Created by Leonardo Cheslacki on 21/08/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

let _this = {};

/**
 *
 */
class HelpersLanguage {

    /**
     *
     * @param props
     */
    constructor(props) {
        this.props = props;
        _this = this;
    };

    get = () => {
        const {locale} = this.props;

        let object = {
            'en-us': {
                jQueryConfirm: {
                    text_confirm: 'View in full screen',
                    text_cancel: 'No thanks'
                }
            },
            'pt-br': {
                jQueryConfirm: {
                    text_confirm: 'Visualizar em tela cheia',
                    text_cancel: 'Não, obrigado'
                }
            }
        }

        return object[locale];
    };
}

/**
 *
 * @type {{locale: Requireable<string>}}
 */
const propTypes = {
    locale: PropTypes.oneOf(['en-us', 'pt-br'])
};

/**
 *
 * @type {{default: {locale: string}}}
 */
const config = {
    default: {
        locale: 'pt-br'
    }
};

export default (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'HelpersLanguage');
    return (new HelpersLanguage(defaultProps));
};